(function () {
  function wrapQuery(raw) {
    var q = String(raw || '').trim().replace(/\s+/g, ' ');
    if (!q) return q;
    if (q.charAt(0) === '"' && q.charAt(q.length - 1) === '"') return q;
    return '"' + q.replace(/"/g, '') + '"';
  }

  function applyToForm(form) {
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    input.value = wrapQuery(input.value);
  }

  window.SeraSearchQuote = {
    wrap: wrapQuery,
    applyToForm: applyToForm,
  };

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      var action = form.getAttribute('action') || '';
      if (action.indexOf('/search') === -1) return;

      applyToForm(form);
    },
    true
  );
})();
